// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__xF_1B","colMin":"styles_colMin__4AxEY"};